import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f9f9f9;
`;

const Logo = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: 24px;
`;

const LoadingText = styled.h2`
  font-size: 20px;
  color: #333;
  margin-bottom: 32px;
`;

const Spinner = styled(motion.div)`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #00a0ff;
  border-radius: 50%;
`;

const AuthLoadingScreen = () => {
  return (
    <Container>
      <Logo src="/logo.png" alt="Логотип" />
      <LoadingText>Приглашаем вас на кухню...</LoadingText>
      <Spinner 
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      />
    </Container>
  );
};

export default AuthLoadingScreen; 